export default function BattleshipPlay() {
  return (
    <div style={{
      fontFamily: "'Georgia', serif",
      backgroundColor: "#2c2c2c",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "32px 40px",
    }}>

      <h1 style={{
        color: "#f9f6f1",
        fontSize: "32px",
        fontWeight: "bold",
        marginBottom: "8px",
      }}>
        Battleship
      </h1>

      <p style={{
        color: "#888",
        fontSize: "14px",
        marginBottom: "24px",
      }}>
        Use a keyboard and mouse. Allow a moment to load.
      </p>

      {/* ↓ Points to your Pygbag files in the public folder */}
      {/* The iframe loads the game as a completely separate page */}
      <iframe
        src="/battleship-game/index.html"
        title="Battleship"
        style={{
          width: "860px",
          height: "640px",         // ← adjust to match your game's resolution
          border: "2px solid #f9f6f1",
          borderRadius: "6px",
          backgroundColor: "#000",
        }}
        allowFullScreen
      />

      
        href="/battleship"
        style={{
          marginTop: "24px",
          fontSize: "14px",
          color: "#888",
          textDecoration: "none",
        }}
      <a>
        ← Back to Project Page
      </a>

    </div>
  );
}